import env from '../../env/env';

const golpointsImg = `${env.REACT_APP_STATIC_BASE_URL}marketplace/img/commons/icons/golpoints.png`;

export { golpointsImg };
